/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum LegalEntityTermsAndConditionsTypesEnum{
  SERVICE_PROVIDER_OFFER_REQ= 'SERVICE_PROVIDER_OFFER_REQ',
  CUSTOMER_OFFER_REQ = 'CUSTOMER_OFFER_REQ'
}
